(() => {
  if (window.GalixContactMotion) {
    window.GalixContactMotion.init(document);
    return;
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rootsWithin = (scope) => {
    const roots = [...scope.querySelectorAll('[data-gx-contact]')];
    if (scope.matches?.('[data-gx-contact]')) roots.unshift(scope);
    return roots;
  };

  function init(scope = document) {
    rootsWithin(scope).forEach((root) => {
      if (root.dataset.contactReady) return;
      root.dataset.contactReady = 'true';
      const controller = new AbortController();
      root._gxContactAbort = controller;
      const { signal } = controller;
      const card = root.querySelector('.gx-contact-card');
      const form = root.querySelector('form');
      const message = root.querySelector('[data-gx-contact-message]');
      const counter = root.querySelector('[data-gx-contact-counter]');
      const submit = root.querySelector('.gx-contact-submit');
      const submitLabel = root.querySelector('[data-gx-contact-submit-label]');
      const success = root.querySelector('[data-gx-contact-success]');
      const fieldsPanel = root.querySelector('[data-gx-contact-fields]');
      const fields = [...(form || root).querySelectorAll('input,textarea')];

      if (success && fieldsPanel) {
        const ownSubmission = window.location.hash === `#${form?.id}`;
        root.classList.toggle('is-success', ownSubmission);
        success.hidden = !ownSubmission;
        fieldsPanel.hidden = ownSubmission;
        if (ownSubmission) {
          const showFromTop = () => requestAnimationFrame(() => {
            window.scrollTo(0, 0);
            success.querySelector('h1')?.focus({ preventScroll: true });
          });
          if (document.readyState === 'complete') showFromTop();
          else window.addEventListener('load', showFromTop, { once: true, signal });
        }
      }

      const syncField = (field) => field.closest('.gx-contact-field')?.classList.toggle('is-filled', field.value.trim().length > 0);
      fields.forEach((field) => {
        syncField(field);
        field.addEventListener('input', () => syncField(field), { signal });
        field.addEventListener('change', () => syncField(field), { signal });
      });

      const syncCounter = () => {
        if (!message || !counter) return;
        const maximum = Number(message.maxLength) || 800;
        counter.value = `${message.value.length} / ${maximum}`;
        counter.textContent = counter.value;
        counter.classList.toggle('is-near-limit', message.value.length >= maximum * .8);
      };
      syncCounter();
      message?.addEventListener('input', syncCounter, { signal });

      form?.addEventListener('focusin', () => card?.classList.add('is-engaged'), { signal });
      form?.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!form.contains(document.activeElement)) card?.classList.remove('is-engaged');
        });
      }, { signal });
      form?.addEventListener('submit', () => {
        if (!submit) return;
        submit.classList.add('is-sending');
        submit.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = submitLabel.dataset.sendingLabel || 'Enviando…';
      }, { signal });

      if (!reducedMotion && matchMedia('(hover:hover) and (pointer:fine)').matches && card) {
        card.addEventListener('pointermove', (event) => {
          const rect = card.getBoundingClientRect();
          card.style.setProperty('--gx-contact-x', `${event.clientX - rect.left}px`);
          card.style.setProperty('--gx-contact-y', `${event.clientY - rect.top}px`);
          card.classList.add('is-pointer-active');
        }, { signal, passive: true });
        card.addEventListener('pointerleave', () => card.classList.remove('is-pointer-active'), { signal });
      }
    });
  }

  function destroy(scope = document) {
    rootsWithin(scope).forEach((root) => {
      root._gxContactAbort?.abort();
      delete root.dataset.contactReady;
    });
  }

  window.GalixContactMotion = { init, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();
